<template>
  <div>
    <v-app-bar dense color="primary" dark app>
      <v-app-bar-nav-icon @click.stop="handleSidenavDrawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->
      <v-menu bottom min-width="200px" rounded offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-avatar color="primary" size="35" style="box-shadow:#1e1e1e69 2px 2px 6px 1px;">
              <span class="white--text text-h5">{{ initials }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list-item-content class="justify-center">
            <div class="mx-auto text-center">
              <v-avatar color="primary">
                <span class="white--text text-h5">{{ initials }}</span>
              </v-avatar>
              <h3>{{ user.loginName }}</h3>
              <p class=" mt-1">
                {{ user.userTypeId == 1001 ? user.doctorName : user.employeeName }}
              </p>
              <!-- <v-divider class="my-3"></v-divider> -->
              <!-- <v-btn depressed rounded text>
                تعديل البيانات
              </v-btn> -->
              <v-divider class="my-3"></v-divider>
              <v-btn depressed rounded color="error" @click="logout()">
                تسجيل خروج
              </v-btn>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-dialog v-model="sessionAlert" max-width="350px" persistent>
      <v-card>
        <v-card-title>تحذير انتهاء صلاحية الجلسة</v-card-title>
        <v-card-text class="py-1">
          <div class="text-h3">{{ counter }}</div>
          <p>نظرًا لأنك كنت غير نشط ، فإن جلستك ستنتهي.</p>
        </v-card-text>
        <v-card-actions class="justify-start">
          <v-btn small color="primary" depressed @click="resetSession">البقاء متصلا</v-btn>
          <v-btn small text @click="logout">تسجيل الخروج</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  // destroyed() {
  //   clearInterval(this.resetSessionAlert);
  // },
  destroyed() {
  clearInterval(this.resetSessionAlert);
  clearInterval(this.keepAliveInterval);
},

  created() {
    this.getInitials();


    this.resetSessionAlert = setInterval(() => {
      if (this.isLoggedIn) {
        this.$store.dispatch("security/resetSession");

        // var dateNow = new Date();
        // if (dateNow - this.lastRequestOn > this.sessionMs) {
        //   if (!this.sessionAlert) {
        //     this.sessionAlert = true;
        //     this.resetCounter = setInterval(this.startCounter, 1000);
        //   }
        // }
      }
    }, 10 * 60 * 1000); // كل 10 دقائق
  },
  computed: {
    user() {
      return this.$store.state.security.user;
    },
    isLoggedIn() {
      return this.$store.state.security.isLoggedIn;
    },  
    lastRequestOn() {
      return this.$store.state.security.lastRequestOn;
    },
    drawer: {

      get() {
        return this.$store.getters["sidebar/isVisibleSideNav"];
      },
      set(value) {
        this.$store.dispatch("sidebar/setSidenavVisibility", value);
      },
    },
  },
  data() {
    return {
      initials: '',

      resetCounter: 0,
      resetSessionAlert: 0,
      sessionAlert: false,
      counter: 60,
      sessionMs: 24 * 60 * 60 * 1000, // 24 ساعة
      searchTerm: "",

      items: [
        // { icon: "person", text: "الملف الشخصي", link: "/profile" },
        {
          icon: "mdi-lock",
          text: "تغيير كلمة المرور",
          link: "/changePassword",
        },
      ],
    };
  },
  methods: {
    getInitials() {

      const rest = this.user.loginName.substring(0, 2);
      const camelCase = rest
        .toLowerCase()
        .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
          index === 0 ? match.toLowerCase() : match.toUpperCase()
        ).replace(/[^a-zA-Z0-9]/g, "");
      this.initials = camelCase;
    },
    startCounter() {
      this.counter--;
      if (this.counter == 0) {
        this.logout();
      }
    },

    resetSession() {
      this.$store.dispatch("security/resetSession").then(() => {
        this.sessionAlert = false;
        clearInterval(this.resetCounter);
        this.counter = 60;
      });
    },
    Search() { },
    logout() {
      this.$store.dispatch("security/logout").then(() => {
        this.$router.replace({ name: "Login" });
      });
    },
    changePassword() { },

    handleSidenavDrawer() {
      this.$store.dispatch("sidebar/setSidenavVisibility");
    },
  },
};
</script>
<style scoped>
.header {
  max-width: 90% !important;

  margin: 0px auto;
}



.v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
  height: 70px !important;
  padding: 10px;
}
</style>
